/**
 * The 35 power-ups (research R§5 "Power-ups (35)", effects traced from the dispatch table D_2D65 /
 * D_2D88; names from geon's editor). A `powerup` item's `item` field indexes this table; the ITEMS
 * stream implements each effect, the renderer draws each by `name`.
 */

export interface Powerup {
  /** geon's editor name, in camelCase: the renderer's model key. */
  name: string;
  /** Displayed points for taking it. */
  points: number;
}

export const POWERUPS: readonly Powerup[] = [
  { name: 'shoe', points: 100 },
  { name: 'whiteStaff', points: 500 },
  { name: 'redStaff', points: 500 },
  { name: 'yellowCandy', points: 100 },
  { name: 'purpleCandy', points: 100 },
  { name: 'blueCandy', points: 100 },
  { name: 'redCross', points: 100 },
  { name: 'yellowCross', points: 100 },
  { name: 'blueCross', points: 100 },
  { name: 'redLamp', points: 100 },
  { name: 'yellowLamp', points: 100 },
  { name: 'purpleLamp', points: 100 },
  { name: 'purpleRing', points: 100 },
  { name: 'redRing', points: 100 },
  { name: 'blueRing', points: 100 },
  { name: 'clock', points: 200 },
  { name: 'greenPotion', points: 200 },
  { name: 'purplePotion', points: 200 },
  { name: 'yellowPotion', points: 200 },
  { name: 'greenCrystalBall', points: 200 },
  { name: 'blueUmbrella', points: 10 },
  { name: 'yellowStaff', points: 500 },
  { name: 'purpleUmbrella', points: 10 },
  { name: 'blueStaff', points: 500 },
  { name: 'powerHeart', points: 1000 },
  { name: 'yellowBox', points: 1000 },
  { name: 'blueBox', points: 1000 },
  { name: 'whiteBox', points: 1000 },
  { name: 'greenLamp', points: 3000 },
  { name: 'bomb', points: 4000 },
  { name: 'purpleCrystalBall', points: 5000 },
  { name: 'bell', points: 8000 },
  { name: 'redDoor', points: 2000 },
  { name: 'whiteDoor', points: 2000 },
  { name: 'lightningPotion', points: 5000 },
];

/** Indices the flow and the other streams name. */
export const RED_DOOR = 32;
export const WHITE_DOOR = 33;
export const LIGHTNING_POTION = 34;

/** A power-up's model key ('' outside the table). */
export const powerupName = (index: number): string => POWERUPS[index]?.name ?? '';
